import { P2GBox } from '@parcel2go/peacock-legacy-core/dist/box';
import { P2GProgress } from '@parcel2go/peacock-legacy-core/dist/progress';
import { P2GText } from '@parcel2go/peacock-legacy-core/dist/typography';
import React, { useEffect, useState } from 'react';
import { getSettings } from './services/api';
import { IAppSettings, Settings } from './settings';

interface props {
  profileId: string;
}

const SettingsWrapper: React.FC<props> = (props) => {
  const [loading, setLoading] = useState<'LOADING' | 'ERROR' | 'LOADED'>('LOADING');

  const onSettingsLoaded = (x: IAppSettings) => {
    Settings.settings = { ...x };
    Settings.profileId = props.profileId;
  };

  useEffect(() => {
    const begin = async () => {
      setLoading('LOADING');
      let settings = await getSettings(props.profileId);
      if (settings && settings.success && settings.result) {
        onSettingsLoaded(settings.result);
        setLoading('LOADED');
      } else {
        setLoading('ERROR');
        setTimeout(begin, 10000);
      }
    };
    if (props.profileId) {
      begin();
    }
  }, [props.profileId]);

  if (loading === 'LOADING') {
    return (
      <P2GBox p={5} textAlign="center">
        <P2GProgress />
        <P2GText component="p">Loading...</P2GText>
      </P2GBox>
    );
  }

  if (loading === 'ERROR') {
    return (
      <P2GBox p={5} textAlign="center">
        <P2GProgress />
        <P2GText component="p">Still Setting Up...</P2GText>
      </P2GBox>
    );
  }

  return <>{props.children}</>;
};

export default SettingsWrapper;
